import {Component} from '@angular/core';
/**
 * \@title Multi-row toolbar
 */
export class ToolbarMultirowExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'toolbar-multirow-example',
  templateUrl: 'toolbar-multirow-example.html',
  styleUrls: ['toolbar-multirow-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ToolbarMultirowExample_tsickle_Closure_declarations() {
/** @type {?} */
ToolbarMultirowExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ToolbarMultirowExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
